import React, {Component, Fragment} from 'react';
import {Button} from 'reactstrap';
import * as customers from 'customers/actions/customers';
import {connect} from 'react-redux';
import {DetailContainer} from 'customers/DetailContainer';
import autobind from 'autobind-decorator';
import Loading from 'apa/components/Loading';
import NewAttachment from './NewAttachment';
import BootstrapTable from 'react-bootstrap-table-next';
import Date from 'apa/components/Date';
import Dialog from 'apa/containers/Dialog';

@connect(
	state => (
		{
			auth: state.apa
		}
	),
	dispatch => (
		{
			fetchAttachments: customer_id => dispatch(customers.fetchAttachments(customer_id)),
		}
	)
)
class DeleteAttachment extends Component {

	constructor(props) {
		super(props);
		this.state = {
			isOpen: false
		}
	}

	@autobind
	toggle() {
		this.setState({isOpen: !this.state.isOpen})
	}

	@autobind
	confirm() {
		const headers = {
			'Authorization': `Token ${this.props.auth.token}`
		};
		fetch(
			`/api/customers/${this.props.attachment.customer}/attachments/?id=${this.props.attachment.id}`,
			{headers, method: 'DELETE'}
		).then(
			() => {
				this.props.fetchAttachments(this.props.attachment.customer);
				this.toggle()
			}
		)
	}


	render() {
		return (
			<Fragment>
				<Button color={'danger'} onClick={this.toggle}>
					<i className='fa fa-trash'> </i>
				</Button>
				<Dialog
					isOpen={this.state.isOpen}
					toggle={this.toggle}
					confirm={this.confirm}
					title={'Datei löschen'}
				>
						Sind Sie sicher?
			</Dialog>
		</Fragment>
		)
	}
}

@connect(
	state => {
		return {
			customers: state.customers
		}
	},
	dispatch => {
		return {
			fetchAttachments: (customer_id) => {
				dispatch(customers.fetchAttachments(customer_id))
			},
			fetchCustomer: (customer_id, callback) => {
				dispatch(customers.fetchCustomer(customer_id, callback))
			}
		}
	}
)
export default class CustomerAttachmentList extends Component {


	constructor(props) {
		super(props);
		this.state = {
			customer: null,
			isLoading: true
		};
	}

	componentDidMount() {
		this.fetchAttachments()
		this.props.fetchCustomer(this.props.match.params.id, c => this.setState({customer: c,
			isLoading: false
		}));
	}

	@autobind
	fetchAttachments() {
		const id = this.props.match.params.id;
		this.props.fetchAttachments(id)
	}

	render() {
		const id = this.props.match.params.id;
		const files = this.props.customers.attachments || [];
		const columnList = [
			{
				text: 'Datum',
				dataField: 'created',
				formatter: cell => <Date date={cell}/>
			},
			{
				text: 'Name',
				dataField: 'name'
			},
			{
				text: 'Link',
				dataField: 'file',
				formatter: cell => <a target="_blank" rel="noopener noreferrer" href={cell}>Download</a>
			},
			{
				text: '',
				dataField: 'id',
				formatter: (cell, row) => <DeleteAttachment attachment={row}/>
			}
		];
		if(this.state.isLoading)
			return <Loading/>
		return (
			<DetailContainer id={id}>
				<h1>{this.state.customer.name}</h1>
				<NewAttachment customer={id}/>
				<BootstrapTable
					keyField='id'
					columns={columnList}
					data={files}
					responsive
					bootstrap4
					striped
				/>
				</DetailContainer>
		)
	}
}

